module.exports = __webpack_public_path__ + "img/bluetooth_on.993e67a5.svg";